import e from "react";
import r from "./index248.mjs";
import { formatPrice as l } from "./index110.mjs";
import { Checkbox as E } from "@amenitiz/design-system";
import { roomsAvailabilityAtom as y } from "./index34.mjs";
import { getInsuranceSelectedAtom as f, setInsuranceSelectedAtom as k } from "./index62.mjs";
import { useAtomValue as s, useSetAtom as v } from "jotai";
import { track as A } from "./index9.mjs";
import { TRACK_EVENT as m } from "./index10.mjs";
import { useHotelConfig as N } from "./index93.mjs";
import { getSubscriptionPlanRoot as h } from "./index14.mjs";
const q = ({
  insuranceInformation: t,
  isLessThanTwoDays: n,
  currency: a
}) => {
  const i = s(f), p = v(k), { hotelId: d, propertySize: u, propertyType: _, subscriptionPlan: b } = N(), c = s(y), g = () => {
    const o = i ? m.REMOVE_FROM_CART : m.ADD_TO_CART;
    p(!i), A(o, o, {
      hotel_id: d,
      property_type: _,
      property_size: u,
      subscription_plan: h(b),
      ecommerce: {
        currency: c.currency,
        value: t.price ? parseFloat(t.price) : 0,
        items: [
          {
            item_id: 1,
            item_name: "Insurance",
            item_type: "insurance",
            price: t.price ? parseFloat(t.price) : 0,
            currency: c.currency,
            quantity: 1
          }
        ]
      }
    });
  };
  return /* @__PURE__ */ e.createElement("div", { "data-testid": "insurance-information", className: r.insurance }, /* @__PURE__ */ e.createElement("div", { className: r["insurance-warning-container"] }, /* @__PURE__ */ e.createElement("div", { className: r["insurance-title-container"] }, /* @__PURE__ */ e.createElement("div", { className: r["insurance-title-container-mobile"] }, /* @__PURE__ */ e.createElement(
    E,
    {
      id: "insurance-checkbox",
      "data-testid": "insurance-checkbox",
      onChange: g,
      value: i,
      disabled: n,
      "aria-labelledby": "insurance-label"
    }
  ), /* @__PURE__ */ e.createElement("span", { id: "insurance-label" }, I18n.t("booking_engine.information.insurance"))), t.price && !n ? /* @__PURE__ */ e.createElement(
    "div",
    {
      "data-testid": "insurance-price-mobile",
      className: r["insurance-price-mobile"]
    },
    l(parseFloat(t.price), a)
  ) : null), n ? /* @__PURE__ */ e.createElement(
    "div",
    {
      "data-testid": "insurance-warning",
      className: r["insurance-warning"]
    },
    I18n.t("booking_engine.information.insurance_warning")
  ) : /* @__PURE__ */ e.createElement("div", { className: r["insurance-sales-terms"] }, I18n.t("booking_engine.information.insurance_sales_terms"), /* @__PURE__ */ e.createElement(
    "a",
    {
      href: t.terms_and_conditions_url,
      target: "_blank",
      rel: "noopener noreferrer"
    },
    I18n.t("booking_engine.payment.terms_and_conditions")
  ), " ", I18n.t("booking_engine.payment.and_the_policy"), " ", /* @__PURE__ */ e.createElement(
    "a",
    {
      href: t.learn_more_url,
      target: "_blank",
      rel: "noopener noreferrer"
    },
    I18n.t("booking_engine.payment.general_conditions")
  ), ".")), t.price && !n ? /* @__PURE__ */ e.createElement(
    "div",
    {
      "data-testid": "insurance-price",
      className: r["insurance-price"]
    },
    l(parseFloat(t.price), a)
  ) : null);
};
export {
  q as Insurance
};
